import React from 'react';
import { useAuth } from '../../utils/context/AuthContext';
// import { useNavigate } from 'react-router-dom';
import Info from '../../components/ProfilePage/Info';
import Settings from '../../components/ProfilePage/Settings';
import DeleteAccount from '../../components/ProfilePage/DeleteAccount';
// Profile page

const Header = () => {
  return (
    <div className="flex flex-row justify-between">
      <h1>My Profile</h1>
    </div>
  );
};
/* is this working */
const Profile = () => {
  const { userData } = useAuth();
  if (!userData) return null;
  return (
    <div className="container mt-5 bg-darkGray p-5 rounded-lg self-start flex flex-col gap-5">
      <Header />
      <div className="flex flex-wrap gap-5 justify-between">
        <Info userData={userData} />
        <Settings />
      </div>

      {/* <ChangePassword /> */}

      <div className="mt-5 self-end">
        <DeleteAccount />
      </div>
    </div>
  );
};

export default Profile;
